module.exports = __webpack_public_path__ + "static/media/spid-idp-sielteid~gPbEKUHE.092e2208.svg";